// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq-selection-container {
    width: 100%;
    height: 100%;
    padding: 0;
    background: white;
    /* Clean white background for container */
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.questions-view,
.themes-view {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    width: 100%;
}

/* Header Styles */
.faq-header {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    background: #ffffff;
    /* White header */
    color: #000000;
    /* Black text */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0;
}

.faq-header h3 {
    margin: 0;
    color: #000000;
    font-size: 1.2rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.faq-header-content {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
}

.faq-header h2 {
    margin: 5px 0 0 0;
    color: #555;
    font-size: 0.95rem;
    font-weight: 500;
    text-transform: none;
    letter-spacing: 0px;
}

.back-btn {
    background: transparent;
    border: 1px solid #ccc;
    color: #333;
    cursor: pointer;
    font-size: 14px;
    margin-right: 15px;
    padding: 6px 12px;
    border-radius: 4px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.back-btn:hover {
    background: #f0f0f0;
    border-color: #999;
}

/* Themes Grid Styling (Rectangle Cards) */
.themes-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 15px;
    padding: 15px 20px;
    overflow-y: auto;
    flex: 1 1;
    background-color: #ffffff;
}

.themes-headline {
    margin: 0;
    padding: 15px 20px 5px 20px;
    color: #000000;
    /* Black headline */
    font-size: 1.1rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    background-color: #ffffff;
}

.theme-card-rect {
    display: flex;
    align-items: center;
    background-color: #ffffff;
    /* White Cards */
    color: #000000;
    /* Black Text */
    padding: 20px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    min-height: 80px;
}

.theme-card-rect:hover {
    background-color: #f8f9fa;
    /* Light Gray on hover */
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    border-color: #ccc;
}

.theme-icon {
    width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.8rem;
    margin-right: 15px;
    color: #000000;
}

.theme-label {
    font-size: 1.1rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    flex: 1 1;
    line-height: 1.3;
}

/* Questions List Styling */
.questions-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: auto;
    flex: 1 1;
    padding: 20px;
    background-color: #ffffff;
}

.question-card {
    background: white;
    padding: 15px 20px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    border-left: 4px solid #000000;
    /* Black accent */
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.question-card:hover {
    background-color: #f8f9fa;
    transform: translateX(5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.question-card p {
    margin: 0;
    color: #333;
    font-size: 0.95rem;
    font-weight: 500;
}

.no-questions {
    text-align: center;
    padding: 40px;
    color: #666;
    font-style: italic;
}

.faq-loading,
.faq-error {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #6c757d;
    font-size: 1.1rem;
}

.faq-error {
    color: #dc3545;
}`, "",{"version":3,"sources":["webpack://./src/components/faq/faqSelection.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,yCAAyC;IACzC,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,yCAAyC;IACzC,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,SAAO;IACP,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,2BAA2B;IAC3B,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,2BAA2B;IAC3B,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,SAAO;IACP,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,SAAO;IACP,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".faq-selection-container {\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    background: white;\n    /* Clean white background for container */\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.questions-view,\n.themes-view {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    overflow: hidden;\n    width: 100%;\n}\n\n/* Header Styles */\n.faq-header {\n    display: flex;\n    align-items: center;\n    padding: 15px 20px;\n    background: #ffffff;\n    /* White header */\n    color: #000000;\n    /* Black text */\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    border-bottom: 1px solid #e0e0e0;\n    flex-shrink: 0;\n}\n\n.faq-header h3 {\n    margin: 0;\n    color: #000000;\n    font-size: 1.2rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.faq-header-content {\n    display: flex;\n    flex-direction: column;\n    margin-left: 15px;\n}\n\n.faq-header h2 {\n    margin: 5px 0 0 0;\n    color: #555;\n    font-size: 0.95rem;\n    font-weight: 500;\n    text-transform: none;\n    letter-spacing: 0px;\n}\n\n.back-btn {\n    background: transparent;\n    border: 1px solid #ccc;\n    color: #333;\n    cursor: pointer;\n    font-size: 14px;\n    margin-right: 15px;\n    padding: 6px 12px;\n    border-radius: 4px;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.back-btn:hover {\n    background: #f0f0f0;\n    border-color: #999;\n}\n\n/* Themes Grid Styling (Rectangle Cards) */\n.themes-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 15px;\n    padding: 15px 20px;\n    overflow-y: auto;\n    flex: 1;\n    background-color: #ffffff;\n}\n\n.themes-headline {\n    margin: 0;\n    padding: 15px 20px 5px 20px;\n    color: #000000;\n    /* Black headline */\n    font-size: 1.1rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    background-color: #ffffff;\n}\n\n.theme-card-rect {\n    display: flex;\n    align-items: center;\n    background-color: #ffffff;\n    /* White Cards */\n    color: #000000;\n    /* Black Text */\n    padding: 20px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: 1px solid #e0e0e0;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n    min-height: 80px;\n}\n\n.theme-card-rect:hover {\n    background-color: #f8f9fa;\n    /* Light Gray on hover */\n    transform: translateY(-2px);\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);\n    border-color: #ccc;\n}\n\n.theme-icon {\n    width: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1.8rem;\n    margin-right: 15px;\n    color: #000000;\n}\n\n.theme-label {\n    font-size: 1.1rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    flex: 1;\n    line-height: 1.3;\n}\n\n/* Questions List Styling */\n.questions-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    overflow-y: auto;\n    flex: 1;\n    padding: 20px;\n    background-color: #ffffff;\n}\n\n.question-card {\n    background: white;\n    padding: 15px 20px;\n    border-radius: 8px;\n    border: 1px solid #e0e0e0;\n    border-left: 4px solid #000000;\n    /* Black accent */\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.question-card:hover {\n    background-color: #f8f9fa;\n    transform: translateX(5px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.question-card p {\n    margin: 0;\n    color: #333;\n    font-size: 0.95rem;\n    font-weight: 500;\n}\n\n.no-questions {\n    text-align: center;\n    padding: 40px;\n    color: #666;\n    font-style: italic;\n}\n\n.faq-loading,\n.faq-error {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    color: #6c757d;\n    font-size: 1.1rem;\n}\n\n.faq-error {\n    color: #dc3545;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
